import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { updateCartProductInfo } from "../Services/Action/Action";

export const useFeaturedProductListQuery = () => {
  return useQuery({
    queryKey: ["product-list"],
    queryFn: async () => {
      const res = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/product/getFeature`,
      });

      let response = res.data.products.data;

      return response;
    },
    refetchOnWindowFocus: false,
  });
};

export const useOfferedProductListQuery = () => {
  return useQuery({
    queryKey: ["offered-product-list"],
    queryFn: async () => {
      const res = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/product/getOffer`,
      });

      let response = res.data.products.data;

      return response;
    },
    refetchOnWindowFocus: false,
  });
};

export const useCartProductListQuery = (idList) => {
  return useQuery({
    queryKey: ["cart-product-list", idList],
    queryFn: async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/product/get-all-ids`,
        {
          params: {
            ids: idList,
          },
        },
      );

      return res.data.data;
    },
    refetchOnWindowFocus: false,
    enabled: idList.length > 0,
  });
};
